import AdminPanelSettingsOutlinedIcon from '@mui/icons-material/AdminPanelSettingsOutlined'
import { Badge } from '@mui/material'
import { useAllHealthPortalNotificationsQuery } from 'types'
import { useEffectiveNotificationKinds } from './Notifications/hooks/useEffectiveNotificationKinds'

const NOTIFICATIONS_POLLING_INTERVAL = 300_000

export const AdminPanelSidebarIcon = () => {
  const { allNotificationKinds } = useEffectiveNotificationKinds()
  const { data: healthPortalNotificationData } = useAllHealthPortalNotificationsQuery({
    variables: {
      forReview: true, // limits the scope of dietitian notifications to the daily ones
      kinds: allNotificationKinds,
      perPage: 20,
      page: 1
    },
    pollInterval: NOTIFICATIONS_POLLING_INTERVAL
  })

  const healthPortalNotifications =
    healthPortalNotificationData?.allHealthPortalNotifications?.healthPortalNotifications || []
  const notificationCount = healthPortalNotifications.filter((notification) => {
    return !notification.completedAt
  }).length

  return (
    <Badge badgeContent={notificationCount} color="primary">
      <AdminPanelSettingsOutlinedIcon />
    </Badge>
  )
}
